import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';

import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { CommonService } from '../../../auth/service/common.service';
import { AccountSettingsService } from '../../../../app/main/pages/account-settings/account-settings.service';
import { ParentParameters, statusCode } from '../../../auth/models/commonEnum';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { MyApplicationService } from '../../my-application/my-application.service';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/auth/service';
import { environment } from 'environments/environment';
import * as CryptoJS from 'crypto-js';

@Component({
	selector: 'app-account-settings',
	templateUrl: './account-settings.component.html',
	styleUrls: ['./account-settings.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AccountSettingsComponent implements OnInit, OnDestroy {
	// public
	public key = environment.cryptoJSKey;
	public iv = environment.cryptoJSIV;
	public contentHeader: object;
	public data: any;
	public birthDateOptions: FlatpickrOptions = {
		altInput: true
	};
	public passwordTextTypeOld = false;
	public passwordTextTypeNew = false;
	public passwordTextTypeRetype = false;
	public avatarImage: string;
	public MinMaxDPdata: NgbDateStruct;
	public updateProfileform: FormGroup;
	public changePasswordform : FormGroup;
	// private
	private _unsubscribeAll: Subject<any>;
	identityProofs: any[];
	public countryArray: any [];
	stateArray: any[];
	districtArray: any[];
	cityArray: any[];
	public tempFiles: any[];
	minDate = this.calendar.getPrev(this.calendar.getToday(), 'y', 100);
	submitted: boolean;
	loading: boolean;
	isDisabled: boolean;
	public DOB: String;
	currentUserId: number;
	expertCategoryName: any;
	isAdmin: boolean;
	isExpert: boolean;
	isUser: boolean;
	currentUserName: string;
	currentUserEmail: string;
	currentUserMobile: string;
	/**
	 * Constructor
	 *
	 * @param {AccountSettingsService} _accountSettingsService
	 */
	constructor(private _accountSettingsService: AccountSettingsService,
		private _formBuilder: FormBuilder,
		private calendar: NgbCalendar,
		private _myApplicationService: MyApplicationService,
		private _authenticationService: AuthenticationService,
		private datePipe: DatePipe,
		private _router: Router,
		private _commonService: CommonService) {
		this._unsubscribeAll = new Subject();

		this.updateProfileform = this._formBuilder.group({
			title: ["", [Validators.required]],
			dateOfBirth: ["", [Validators.required]],
			gender: ['M', [Validators.required]],
			department: ['', [Validators.required]],
			designation: ['', [Validators.required]],
			identityProof: [],
			profilePhoto: ['Select file'],
			profilePhotoFileName : [],
			institute: ['', [Validators.required]],
			expertCategory:[''],
			userName:[''],
			userEmail:[''],
			userMobile:[''],
			instituteAddress: ['', [Validators.required]],
			address1: [''],
			address2: [''],
			country: [],
			state: [],
			district: [],
			city: [],
			pincode: [],
			landline: []
		});
		this.changePasswordform = this._formBuilder.group({
			password : ['',[Validators.required]],
			newPassword : ['',[Validators.required]],
			confirmNewPassword : ['',[Validators.required]]
		})
	}


	// Public Methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Toggle Password Text Type Old
	 */
	togglePasswordTextTypeOld() {
		this.passwordTextTypeOld = !this.passwordTextTypeOld;
	}

	/**
	 * Toggle Password Text Type New
	 */
	togglePasswordTextTypeNew() {
		this.passwordTextTypeNew = !this.passwordTextTypeNew;
	}

	/**
	 * Toggle Password Text Type Retype
	 */
	togglePasswordTextTypeRetype() {
		this.passwordTextTypeRetype = !this.passwordTextTypeRetype;
	}

	// /**
	//  * Upload Image
	//  *
	//  * @param event
	//  */
	// uploadImage(event: any) {
	// 	if (event.target.files && event.target.files[0]) {
	// 		let reader = new FileReader();

	// 		reader.onload = (event: any) => {
	// 			this.avatarImage = event.target.result;
	// 		};

	// 		reader.readAsDataURL(event.target.files[0]);
	// 	}
	// }

	// Lifecycle Hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit() {
		this.loadidentityProofData();
		this.getCountryDetails();
		this.getProfileDetails();
		this.currentUserId = this._authenticationService.currentUserValue.id;
		this.expertCategoryName =  this._authenticationService.currentUserValue.expertCategory;
		this.isAdmin = this._authenticationService.isAdmin;
		this.isExpert = this._authenticationService.isExpert;
		this.isUser = this._authenticationService.isUser;
		this.currentUserName = this._authenticationService.currentUserValue.name;
		this.currentUserEmail = this._authenticationService.currentUserValue.email;
		this.currentUserMobile = this._authenticationService.currentUserValue.mobile;

		// this.currentUserName = this._authenticationService.
		this.updateProfileform.controls.expertCategory.setValue(this.expertCategoryName);
		this.updateProfileform.controls.userName.setValue(this.currentUserName);
		this.updateProfileform.controls.userEmail.setValue(this.currentUserEmail);
		this.updateProfileform.controls.userMobile.setValue(this.currentUserMobile);
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
	loadidentityProofData() {
		this._commonService.getParameterSettings(ParentParameters.IDENTITY_PROOF).subscribe((result: any) => {
			this.identityProofs = [];
			if (result.statusCode == 200) {
				result["data"]["response"].forEach(element => {
					this.identityProofs.push({
						identityProofName: element.paraDescription,
						identityProofID: element.paraId
					});
				});
			}
		});
	}
	
	getCountryDetails() {
		this._commonService.getCountryData().subscribe((result: any) => {
			this.countryArray = [];
			if (result.statusCode == 200) {
				result["data"]["response"].forEach(element => {
					this.countryArray.push({
						countryName: element.name,
						countryID: element.id
					});
				});
			}
		});
	}
	getstateDetails(event: any) {
		var countryId = event.countryID;
		this._commonService.getStateData(countryId).subscribe((result: any) => {
			this.stateArray = [];
			if (result.statusCode == 200) {
				result["data"]["response"].forEach(element => {
					this.stateArray.push({
						stateName: element.name,
						stateID: element.id
					});
				});
			}
		});
	}
	getCityDistrictDetails(event: any) {
		var stateId = event.stateID;
		this._commonService.getDistrictData(stateId).subscribe((result: any) => {
			this.cityArray = [];
			if (result.statusCode == 200) {
				result["data"]["response"].forEach(element => {
					this.cityArray.push({
						cityName: element.districtTitle,
						cityID: element.id
					});
				});
			}
		});
	}
	browsbuttonClick(name) {
		if (name === 'uploadProfile') {
			this.updateProfileform.controls.profilePhoto.setValue("Select file");
		}
		if (this.myFiles.length > 0) {
			this.myFiles.forEach((element, i) => {
				if (element.key == name) {
					this.myFiles.splice(i, 1);
				}
			});
		}
	}
	public myFiles = [];
	onFileChange(event: any, name: string) {
		for (var i = 0; i < event.target.files.length; i++) {
			//this.myFiles = [];
			this.tempFiles = [];
			var key = name;
			this.myFiles.push({ key: key, file: event.target.files[i] });
			// this.tempFiles.push({ key: key, file: event.target.files[i] });
			if (name === 'uploadProfile') {
				this.updateProfileform.controls.profilePhoto.setValue(this.showFiles(this.myFiles));
			}
		}
	}
	showFiles(documentList: any) {
		let files = '';
		for (let i = 0; i < documentList.length; i++) {
			files += documentList[i].file.name;
			if (!(documentList.length - 1 === i)) {
				files += ',';
			}
		}
		return files;
	}
	/**
	 * Get FormData
	 */
	 get profileData() {
		return this.updateProfileform.controls;
	}
	/**
	 * function for set start Min and reset end date if first selected. 
	 ***/
	setStartMinDate() {
		if (this.updateProfileform.controls.dateOfBirth.value != undefined && this.updateProfileform.controls.dateOfBirth.value != null) {
			//Reset End Date field
			this.updateProfileform.controls.dateOfBirth.setValue("");
		}
	}
	/**
	 * function for save profile data. 
	 ***/
	saveProfileData() {
		this.submitted = true;
		if (this.updateProfileform.invalid) {
			return false;
		}
		const data = this.prepareSave();
		this.loading = true;
		this._myApplicationService
			.submitProfileData(data).pipe(first())
			.subscribe(
				response => {

					if (Number(response["statusCode"]) === statusCode.SUCCESS) {
						this.loading = false;
						this.submitted = false;
						Swal.fire({
							icon: 'success',
							title: 'Success!',
							text: 'Profile Updated successfully.',
							customClass: {
								confirmButton: 'btn btn-success'
							}
						});
						this._router.navigate(['/my-application']);
					}
					else {
						// this.error = response["message"];
						this.isDisabled = false;
						this.loading = false;
						Swal.fire({
							icon: 'error',
							title: 'Error!',
							text: response["message"],
							customClass: {
								confirmButton: 'btn btn-error'
							}
						});
					}
				},
			);

		return false;
	}
	prepareSave() {
		let input: FormData = new FormData();
		input.append('title',this.updateProfileform.controls.title.value);
		let DOBData = this.updateProfileform.controls.dateOfBirth.value;
		let DOB = DOBData.year + '-' + DOBData.month + '-' + DOBData.day;
		input.append('dateOfBirth', this.datePipe.transform(DOB, "yyyy-MM-dd"));

		input.append('gender',this.updateProfileform.controls.gender.value );
		input.append('department',this.updateProfileform.controls.department.value );
		input.append('designation',this.updateProfileform.controls.designation.value );
		input.append('identityProof',this.updateProfileform.controls.identityProof.value );
		input.append('institute',this.updateProfileform.controls.institute.value );
		input.append('instituteAddress',this.updateProfileform.controls.instituteAddress.value );
		input.append('country',this.updateProfileform.controls.country.value );
		input.append('state',this.updateProfileform.controls.state.value );
		input.append('city',this.updateProfileform.controls.city.value );
		input.append('address1',this.updateProfileform.controls.address1.value );
		input.append('address2',this.updateProfileform.controls.address2.value );
		input.append('pincode',this.updateProfileform.controls.pincode.value );
		input.append('landline',this.updateProfileform.controls.landline.value );
		
		return input;
	}
	getProfileDetails() {
		this.avatarImage = 'assets/images/avatars/detaultProfile.jpg';
		this._myApplicationService.getProfileData().subscribe((result: any) => {
			this.data = result;
			const profileDetails = this.data['data']['response'];
			if(this.isValidData(profileDetails) &&  profileDetails.id > 0){
				this.updateProfileform.patchValue(profileDetails);
				if(profileDetails.country > 0){
					this._commonService.getStateData(profileDetails.country).subscribe((result: any) => {
						this.stateArray = [];
						if (result.statusCode == 200) {
							result["data"]["response"].forEach(element => {
								this.stateArray.push({
									stateName: element.name,
									stateID: element.id
								});
							});
							this.updateProfileform.controls.state.setValue(profileDetails.state);
						}
					});
				}
				if(profileDetails.state > 0){
					this._commonService.getDistrictData(profileDetails.state).subscribe((result: any) => {
						this.cityArray = [];
						if (result.statusCode == 200) {
							result["data"]["response"].forEach(element => {
								this.cityArray.push({
									cityName: element.districtTitle,
									cityID: element.id
								});
							});
						}
						this.updateProfileform.controls.city.setValue(profileDetails.city);
					});
				}
				let [year, month, day] = ['','',''];
				let obj = null;
				this.DOB = profileDetails.dateOfBirth;
				if(this.isValidData(this.DOB)){
					[day, month, year] = this.DOB.split('-');
				obj = { year: parseInt(year), month: parseInt(month), day: 
					parseInt(day.split(' ')[0].trim()) };
				this.updateProfileform.controls.dateOfBirth.setValue(obj);
				}
				if(this.isValidData(profileDetails.profilePhoto)){
					this.avatarImage = profileDetails.profilePhoto;
				}
			}
		});
	}
	isValidData(data){
		if(data != null && data != undefined && data != ''){
			return true;
		}
		return false;
	}
	changePassword(){
		const encryptedPassword = CryptoJS.HmacSHA256(this.changePasswordform.get('password').value, this.key).toString();
		const encryptedNewPassword = CryptoJS.HmacSHA256(this.changePasswordform.get('newPassword').value, this.key).toString();
		this.submitted = true;
		if (this.changePasswordform.invalid) {
			return false;
		}
		const data = {
			password : encryptedPassword,
			newPassword : encryptedNewPassword,
		}
		this.loading = true;
		this._myApplicationService
			.updatePassword(data).pipe(first())
			.subscribe(
				response => {
					if (Number(response["statusCode"]) === statusCode.SUCCESS) {
						this.isDisabled = false;
						this.submitted = false;
						Swal.fire({
							icon: 'success',
							title: 'Success!',
							text: 'Password updated successfully.',
							customClass: {
								confirmButton: 'btn btn-success'
							}
						});
						// this._router.navigate(['/my-application']);
					}
					else {
						// this.error = response["message"];
						this.isDisabled = false;
						this.loading = false;
						Swal.fire({
							icon: 'error',
							title: 'Error!',
							text: response["message"],
							customClass: {
								confirmButton: 'btn btn-error'
							}
						});
					}
				},
			);

		return false;
	}
	/**
	 * Get FormData
	 */
	 get updatePassword() {
		return this.changePasswordform.controls;
	}
}
